import { apiClient } from '@repo/shared';

const initialiseNewAttendance = () => {
  return {
    class: {},
    attendances: [],
  };
}

const getForEvent = async (eventId) => {
  const attendancesResponse = await apiClient.get(`/api/events/${eventId}/attendance`);
  const attendances = attendancesResponse.map(a => { return {...a, eventDate: new Date(a.eventDate)} });
  return attendances;
};

const update = async ({eventId, attendances} ) => {
  return await apiClient.post(`/api/events/${eventId}/attendance`, attendances);
};


const EventAttendanceService = {
    getForEvent,
    update,
    initialiseNewAttendance,
  };
  
  export default EventAttendanceService;